import { Dialog, DialogTitle, DialogContent, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import CustomTextField from "../custom/CustomTextField";
import { isBlank } from "../../utils/ValidationRules";
import CustomButton from "../custom/CustomButton";
import apiClient from "../../utils/apiClient";
import Swal from "../../utils/swal";
import { showSuccessToast, showErrorToast } from "../../utils/swalToast";

const EditPengajaranModal = ({ open, onClose, userId, instructId, onSuccess }) => {
  const [mataKuliah, setMataKuliah] = useState("");

  useEffect(() => {
    if (!open || !instructId) return;

    const fetchInstructData = async () => {
      try {
        const response = await apiClient.get(
          `/instruct?id=${instructId}&lecturerId=${userId}`
        );
        const data = response.data.data[0];
        setMataKuliah(data.mata_kuliah);
      } catch (err) {
        showErrorToast("Failed to fetch instruct data");
      }
    };
    fetchInstructData();
  }, [instructId, userId, open]);

  const editPengajaran = (event) => {
    event.preventDefault();
    Swal.fire({
      text: "Masukkan pengajaran baru ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ya, masukan",
      cancelButtonText: "Tidak, jangan masukkan",
      confirmButtonColor: "#003158",
      cancelButtonColor: "#A92027",
    }).then((result) => {
      if (result.isConfirmed) {
        apiClient
          .put(`/instruct`, {
            id: instructId,
            mataKuliah: mataKuliah,
          })
          .then((response) => {
            showSuccessToast(response.data.msg);
            onSuccess();
          })
          .catch((err) => {
            showErrorToast(err.response.data.msg);
          });
      }
    });
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Edit Pengajaran</DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item md={12} xs={12}>
            <Typography>
              Mata Kuliah<span style={{ color: "red" }}>*</span>
            </Typography>
            <CustomTextField
              value={mataKuliah}
              rule={(value) => isBlank(value, "Mata Kuliah")}
              onChange={(event) => setMataKuliah(event.target.value)}
            />
          </Grid>
          <Grid item md={12} xs={12}>
            <CustomButton
              text="Submit"
              baseColor="#003158"
              hoverColor="#00213A"
              onClick={editPengajaran}
            />
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default EditPengajaranModal;
